import Vue from 'vue';

export default class EventManager {
  private vue: Vue;

  constructor() {
    this.vue = new Vue();
  }

  public fire(event: string, data: any = null) {
    this.vue.$emit(event, data);
  }

  // tslint:disable-next-line
  public listen(event: string, callback: Function) {
    this.vue.$on(event, callback);
  }

  // tslint:disable-next-line
  public offline(event: string, callback: Function) {
    this.vue.$off(event, callback);
  }
}
